export const LONG_ROUTE_MIN_KM = 300

export const BIG_CHANGE_RATIO = 0.25

const arsRoute = (key, label, subtitle, exampleKm) => ({
  id: key,
  label,
  subtitle,
  exampleKm,
  price: ['price_per_km', 'ARS', key],
  multiplier: ['max_price_multiplier', 'ARS', key]
})

export const GROUPS = [
  {
    currency: 'ARS',
    label: 'Argentina',
    round: 250,
    rows: [
      arsRoute('la-costa', 'La Costa', 'CABA → Mar del Plata', 415),
      arsRoute('rosario', 'Rosario', 'CABA → Rosario', 300),
      arsRoute('uy-ar', 'Uruguay ↔ Argentina', 'Cobrado en pesos argentinos', null),
      arsRoute('costa-rosario', 'Costa → Rosario', null, null),
      arsRoute('sde-tuc', 'SDE → Tucumán', 'Santiago del Estero → Tucumán', 162),
      arsRoute('salta-jujuy', 'Salta → Jujuy', null, 128),
      arsRoute('salta-tuc', 'Salta → Tucumán', null, 311),
      arsRoute('jujuy-tuc', 'Jujuy → Tucumán', null, 333),
      arsRoute('rc-cba', 'Río Cuarto → Córdoba', null, 214),
      arsRoute('mza-sj', 'Mendoza → San Juan', null, 170),
      arsRoute('caba-tandil', 'CABA → Tandil', null, 350),
      arsRoute('santa-fe-rosario', 'Santa Fe → Rosario', null, 173)
    ]
  },
  {
    currency: 'UYU',
    label: 'Uruguay',
    round: 5,
    rows: [
      {
        id: 'uyu-short',
        label: 'Tramo corto',
        subtitle: `Hasta ${LONG_ROUTE_MIN_KM} km · ej. Montevideo → Maldonado`,
        exampleKm: 130,
        price: ['price_per_km', 'UYU', 'DEFAULT'],
        multiplier: ['max_price_multiplier', 'UYU'],
        multiplierScope: 'Todos los tramos'
      },
      {
        id: 'uyu-long',
        label: 'Tramo largo',
        subtitle: `Más de ${LONG_ROUTE_MIN_KM} km`,
        exampleKm: 490,
        price: ['price_per_km', 'UYU', 'LONG'],
        multiplier: ['max_price_multiplier', 'UYU'],
        sharesMultiplier: true
      }
    ]
  },
  {
    currency: 'USD',
    label: 'Internacional',
    round: 1,
    rows: [
      {
        id: 'usd',
        label: 'Todas las rutas',
        subtitle: 'Fuera de Argentina y Uruguay',
        exampleKm: null,
        price: ['price_per_km', 'USD'],
        multiplier: ['max_price_multiplier', 'USD']
      }
    ]
  }
]

export const fieldId = path => path.join('.')

export const FIELDS = GROUPS.flatMap(group =>
  group.rows.flatMap(row => [
    {
      id: fieldId(row.price),
      path: row.price,
      kind: 'price',
      group,
      scope: row.label
    },
    ...(row.sharesMultiplier
      ? []
      : [
          {
            id: fieldId(row.multiplier),
            path: row.multiplier,
            kind: 'multiplier',
            group,
            scope: row.multiplierScope ?? row.label
          }
        ])
  ])
)
